/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_TitleInputs */

const en_to_xml_title = /** @type {(inputs: To_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to XML Converter`)
};

const ko_to_xml_title = /** @type {(inputs: To_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → XML 변환기`)
};

const ja_to_xml_title = /** @type {(inputs: To_Xml_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → XML変換ツール`)
};

/**
* | output |
* | --- |
* | "JSON to XML Converter" |
*
* @param {To_Xml_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_title = /** @type {((inputs?: To_Xml_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_title(inputs)
	if (locale === "ko") return ko_to_xml_title(inputs)
	return ja_to_xml_title(inputs)
});